const KEY = "mars_ref";
const PARAMS = ["ref", "affiliate", "aff", "r"];

const clean = (value) => String(value || "").trim().slice(0, 24);

export function refFromSearch(search) {
  const params = new URLSearchParams(search || (typeof window !== "undefined" ? window.location.search : ""));
  for (const key of PARAMS) {
    const hit = clean(params.get(key));
    if (hit) return hit;
  }
  return "";
}

export function readRef() {
  try {
    return clean(sessionStorage.getItem(KEY)) || refFromSearch();
  } catch {
    return refFromSearch();
  }
}

export function writeRef(value) {
  const next = clean(value);
  try {
    if (next) sessionStorage.setItem(KEY, next);
    else sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  return next;
}

export function captureRef(search) {
  const fromUrl = refFromSearch(search);
  if (fromUrl) return writeRef(fromUrl);
  return readRef();
}

export function clearRef() {
  writeRef("");
}
